import { IMember, IUser } from "../schemas/entity_set";
import { IModelService, IModelFilter, IRequestResult } from "../schemas/structure"
import { StoreKeys } from '../helpers/config_keys';

interface IMemberFilter extends IModelFilter { }

interface IMemberService extends IModelService<IMember> {
    searchConfig(): Object
    info(id: number): angular.IPromise<IRequestResult<IMember>>
    accountStatement(id: number): angular.IPromise<IRequestResult<string>>
    closeAccount(id: number): angular.IPromise<IRequestResult<IMember>>
    query(params: IMemberFilter): angular.IPromise<IRequestResult<Array<IMember>>>
    upload(members: IMember[]): angular.IPromise<IRequestResult<boolean>>
}

let user: IUser = JSON.parse(localStorage.getItem(StoreKeys.CurrentUser))

class MemberService implements IMemberService {

    static $inject = ["$q", "$http", "BASEAPI", "$uibModal"];

    constructor(private $q: angular.IQService,
        private $http: angular.IHttpService,
        private baseUrl: string,
        private $uibModal: angular.ui.bootstrap.IModalService) { }

    get() {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/member`).then((response: IRequestResult<Array<IMember>>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    upload(members: IMember[]) {
        let defer = this.$q.defer();
        this.$http.post(`${this.baseUrl}/member/upload`, members).then((response: IRequestResult<boolean>) => {
            defer.resolve(response)
        })
        return defer.promise
    }


    searchConfig() {
        return {
            params: {
                headers: {
                    "Authorization": "Bearer " + user.token,
                    "Content-Type": "application/json",
                },
            },
            url: "/api/member/search",
            dataType: "json",
            data: (term: string, page: string) => {
                return { q: term };
            },
            results: (response: IRequestResult<Array<IMember>>, page: number) => {
                return { results: response.data };
            },
            cache: true
        }
    }

    find(id: number) {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/member?id=${id}`).then((response: IRequestResult<IMember>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    closeAccount(id: number) {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/member/closeaccount?id=${id}`).then((response: IRequestResult<IMember>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    info(id: number) {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/member/info?id=${id}`).then((response: IRequestResult<IMember>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    accountStatement(id: number) {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/member/accountstatement?id=${id}`).then((response: IRequestResult<string>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    query(params: IMemberFilter) {
        let defer = this.$q.defer()
        this.$http.post(`${this.baseUrl}/member/query`, params).then((response: IRequestResult<Array<IMember>>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    save(member: IMember) {
        let defer = this.$q.defer()
        if (member.id) {
            this.$http.put(`${this.baseUrl}/member`, member).then((response: IRequestResult<IMember>) => {
                defer.resolve(response)
            })
        } else {
            this.$http.post(`${this.baseUrl}/member`, member).then((response: IRequestResult<IMember>) => {
                defer.resolve(response)
            })
        }
        return defer.promise
    }

    delete(id: number) {
        let defer = this.$q.defer()
        this.$http.delete(`${this.baseUrl}/member?id=${id}`).then((response: IRequestResult<IMember>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

}

export { MemberService, IMemberService, IMemberFilter }


// WEBPACK FOOTER //
// ./app/members/member_service.ts